import React, { Component } from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';

class CheckIdentityPage extends Component {
  render() {
    const { saveCheckIdentityForm } = this.props;
    return (
      <Form
        onSubmit={saveCheckIdentityForm}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({ checkIdentityPageTitle = '', checkIdentityIntro }) => (
                <StandardBody>
                  <PageHeading>{checkIdentityPageTitle}</PageHeading>
                  <p>{checkIdentityIntro}</p>
                  <NavigationButton.Primary willSubmitForm labelText={`Continue`} />
                </StandardBody>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
CheckIdentityPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveCheckIdentityForm: PropTypes.func.isRequired
};

export default CheckIdentityPage;
